// ─────────────────────────────────────────────────────────────────────────────
// 🚨 A FIGURE A MODEL RETURNS IS NOT A NUMBER UNTIL SOMETHING MAKES IT ONE.
//
// Jesse: "Still zeros for both income and assets on Financials tab. Why is the
// AI not extracting the data? This used to work perfectly."
//
// 🔑 IT WAS EXTRACTING. Cathy's run returned qualifyingMonthly = "5,388" —
// right to the dollar, formatted with a thousands separator — and this file's
// two callers did `Number(...)`, which is NaN. Her earlier run returned 5703,
// bare, which is why the same code worked then.
//
// ⚠️ A DELIBERATE DUPLICATE of backend/utils/parseModelNumber.js, because the
// browser cannot require it. The rules are kept identical and the reasoning
// lives in the backend copy: strip formatting, then demand a plain number so a
// range or a prose hedge REFUSES rather than silently becoming its first group,
// never parseFloat (parseFloat("5,388") is 5), and preserve a genuine 0.
// ─────────────────────────────────────────────────────────────────────────────

const FORMATTING = /[$£€,\s]/g;
const PLAIN_NUMBER = /^-?\d+(?:\.\d+)?$/;

export function parseModelNumber(v) {
  if (v === null || v === undefined) return null;
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  if (typeof v === 'boolean') return null;
  // 🚨 ONLY A STRING FROM HERE. String([5388, 6000]) is "5388,6000", and
  // stripping the separator turns a two-element array into 53886000 — a
  // concatenation presented as a balance. Found by the suite's "an array →
  // null" case, which was written as a formality and was not one.
  if (typeof v !== 'string') return null;
  const s = v.trim();
  if (s === '') return null;
  const cleaned = s.replace(FORMATTING, '');
  if (!PLAIN_NUMBER.test(cleaned)) return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}

/** As above, refusing negatives — for amounts that cannot be below zero. */
export function parseModelAmount(v) {
  const n = parseModelNumber(v);
  return n === null || n < 0 ? null : n;
}
